import * as React from 'react';
import { makeStyles, tokens } from '@fluentui/react-components';
import { Footer, LoggedOutHeader, SkipToMain } from '../components';

interface Props {
  children: React.ReactNode;
}

export default function LoggedOutLayout({ children }: Props) {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <SkipToMain id="main" />
      <LoggedOutHeader />

      <main id="main" className={classes.content}>
        {children}
      </main>

      <Footer />
    </div>
  );
}

const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
    backgroundColor: tokens.colorNeutralBackground1,
    overflowX: 'hidden',
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    flexGrow: 1,
  },
});
